export const BASE_URL = process.env.REACT_APP_ROCKY_BACKEND_BASE_URL;
export const TRACKER_BASE_URL = process.env.REACT_APP_TRACKER_URL;
export const K2ACCOUNTS_BASE_URL = process.env.REACT_APP_K2ACCOUNTS_BASE_URL+`/auth/login`;
